import { SyncScraperConfig } from './SyncScraperConfig'

/**
 * Sync state between legacy systems that do not support hooks
 *
 * @returns JSX.Element
 */
export const LegacyStateSync = (): JSX.Element => {
  return (
    <>
      <SyncScraperConfig />
    </>
  )
}
